import { Box, chakra } from '@chakra-ui/react';
import { FC } from 'react';

import styles from './styles.module.scss';

interface Props {
  text: string;
}

const HtmlText: FC<Props> = ({ text, ...props }) => {
  return (
    <Box {...props} dangerouslySetInnerHTML={{ __html: text }} className={styles.htmlText}/>
  );
};

export default chakra(HtmlText);
